(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check/assets/javascripts/cookie-check.js') >= 0) return;  svs.modules.push('/components/components/cookies-check/assets/javascripts/cookie-check.js'); 'use strict';

var cookieSeparator = ',';

function parseCookieData(cookie) {
  var inverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var tur = Boolean(inverse);
  var sport = Boolean(inverse);
  var vattendelaren = Boolean(inverse);
  var cookieArray = [];

  if (typeof cookie === 'string' && cookie.indexOf(cookieSeparator) !== -1) {
    cookieArray = cookie.split(cookieSeparator);

    if (cookieArray.length === 3) {
      tur = cookieArray[0] === 't';
      sport = cookieArray[1] === 't';
      vattendelaren = cookieArray[2] === 't';
    }
  }

  return {
    sport: sport,
    tur: tur,
    vattendelaren: vattendelaren
  };
}

function isDivider() {
  if (svs.core.data.baseUrl === '' && $('html.divider').length > 0) {
    return true;
  }

  return false;
}

function getUniqueCookieValue(cookieName) {
  var invert = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var cookieValue = decodeURIComponent(svs.utils.cookie.read(cookieName));
  var valueCookie = parseCookieData(cookieValue, invert);
  var returnValue = false;

  if (svs.core.data.tenant === 'tb') {
    if (isDivider()) {
      returnValue = !invert;
    } else {
      returnValue = valueCookie.tur;
    }
  } else if (svs.core.data.tenant === 'lb') {
    returnValue = valueCookie.sport;
  }

  return returnValue;
}

function init() {
  if (getUniqueCookieValue('show-cookie-info', true) && window.location.pathname.indexOf('/villkor-och-integritet') < 0) {
    svs.core.module.load('/cl/components/cookies-info', null, function (error) {
      if (error) {
        var logger = svs.core.log.getLogger('component:cookies-check');
        logger.error('Failed to load components/cookies-info', error);
      } else {
        svs.components.cookies_info.cookieInfo.show();
      }
    });
  }
}


$(function () {
  setTimeout(init, 1000);
});
 })(window);